const PackageTypesDifferencesIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2206_10696)" />
      <g clip-path="url(#clip0_2206_10696)">
        <path
          d="M31.2613 50.9996H38.7396C39.2033 50.9996 39.5512 50.6518 39.5512 50.1881V47.8692C39.5512 47.4054 39.2033 47.0576 38.7396 47.0576H31.2613C30.7975 47.0576 30.4497 47.4054 30.4497 47.8692V50.1881C30.4497 50.5938 30.8555 50.9996 31.2613 50.9996Z"
          fill="white"
        />
        <path
          d="M34.9713 24.4492C34.3916 24.4492 33.9858 24.913 33.9858 25.4347V48.2173C33.9858 48.797 34.4496 49.2028 34.9713 49.2028C35.5511 49.2028 35.9569 48.7391 35.9569 48.2173V25.4347C36.0148 24.913 35.5511 24.4492 34.9713 24.4492Z"
          fill="white"
        />
        <path
          d="M35.029 23.8115C36.3624 23.8115 37.4638 22.71 37.4638 21.3767C37.4638 20.1013 36.3624 18.9419 35.029 18.9419C34.3913 18.9419 33.7537 19.2317 33.2899 19.6955C32.8261 20.1593 32.5942 20.797 32.5942 21.4346C32.5942 22.768 33.6957 23.8115 35.029 23.8115Z"
          fill="white"
        />
        <path
          d="M39.7251 37.1445L39.7831 37.4924C40.2468 40.3909 43.0874 42.5358 46.3918 42.5358C46.4497 42.5358 46.5657 42.5358 46.6236 42.5358C50.0439 42.4199 52.8265 40.275 53.1164 37.4924L53.1744 37.2025H39.7251V37.1445Z"
          fill="white"
        />
        <path
          d="M51.8408 35.0577L47.551 22.3041H49.6959C50.1597 22.3041 50.5655 21.8983 50.5655 21.4345C50.5655 20.9707 50.1597 20.5649 49.6959 20.5649H38.1597C38.4495 20.8548 38.4495 21.9562 38.1597 22.3041H45.2321L40.9423 35.1157C40.7684 35.5794 41.0582 36.0432 41.464 36.2171C41.9278 36.391 42.3916 36.1012 42.5655 35.6954L46.3336 24.3331L50.1017 35.6954C50.2756 36.1591 50.7394 36.391 51.2031 36.2171C51.7249 35.9852 52.0147 35.5215 51.8408 35.0577Z"
          fill="white"
        />
        <path
          d="M30.2756 37.1445L30.2176 37.4924C29.7538 40.3909 26.9133 42.5358 23.6089 42.5358C23.5509 42.5358 23.435 42.5358 23.377 42.5358C19.9567 42.4199 17.1741 40.275 16.8843 37.4924V37.1445H30.2756Z"
          fill="white"
        />
        <path
          d="M18.1594 35.0577L22.4493 22.3041H20.3043C19.8406 22.3041 19.4348 21.8983 19.4348 21.4345C19.4348 20.9707 19.8406 20.5649 20.3043 20.5649H31.8406C31.5507 20.8548 31.5507 21.9562 31.8406 22.3041H24.7681L29.0579 35.1157C29.2319 35.5794 28.942 36.0432 28.5362 36.2171C28.0724 36.391 27.6087 36.1012 27.4348 35.6954L23.6087 24.2751L19.7826 35.6374C19.6087 36.1012 19.1449 36.3331 18.6811 36.1591C18.2753 35.9852 17.9855 35.5215 18.1594 35.0577Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2206_10696"
          x1="34.5455"
          y1="0"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#49912D" />
          <stop offset="1" stop-color="#33691E" />
        </linearGradient>
        <clipPath id="clip0_2206_10696">
          <rect width="36.2319" height="32" fill="white" transform="translate(16.8843 19)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PackageTypesDifferencesIconSubcategory
